import React, { Fragment, useLayoutEffect } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import {
  Button,
  TextField,
  CdsamCityAndStateSelect
} from "components"
import classes from "./index.module.scss"

const PoAddressDetails = props => {
  const {
    formErrors,
    customerAddress,
    setCustomerAddress,
    setDeliveryFees
  } = props

  const [t] = useTranslation()

  const locationOptions =
    useSelector((state) =>
      state.systemSettings.locationOptions
    )

  const handleChange = (value, name) => {
    setCustomerAddress((prev) =>
      ({ ...prev, [name]: value })
    )
  }

  const handleEditAddress = () => {
    setCustomerAddress(prev => ({ ...prev, _id: "" }))
  }

  const onAreaNameChanged = () => {
    const locationOption =
      locationOptions[0]

    if (!locationOption) return

    setDeliveryFees({
      quotationId: "",
      fee: locationOption.deliveryFee
    })

    setCustomerAddress(prev => ({
      ...prev,
      areaName: locationOption.areaName
    }))
  }

  useLayoutEffect(() => {
    onAreaNameChanged()
  }, [])

  const disabled = !!customerAddress._id

  return (
    <Fragment>
      <div className={classes["title"]}>
        {t("جزئیات_آدرس")}
      </div>

      <div className={classes["container"]}>
        <CdsamCityAndStateSelect
          disabled={disabled}
          form={customerAddress}
          setForm={setCustomerAddress}
          formErrors={formErrors}
        />
        <TextField
          type="text"
          label={t("آدرس")}
          disabled={disabled}
          className={classes["input"]}
          value={customerAddress.address}
          onChange={(e) => handleChange(e.target.value, "address")}
          error={formErrors.address}
        />
        <TextField
          type="text"
          label={t("کدپستی")}
          disabled={disabled}
          className={classes["input"]}
          value={customerAddress.zipCode}
          onChange={(e) => handleChange(e.target.value, "zipCode")}
          error={formErrors.zipCode}
        />
        <TextField
          label={t("نام_گیرنده")}
          disabled={disabled}
          value={customerAddress.recipientName}
          error={formErrors.recipientName}
          className={classes["input"]}
          onChange={(e) => handleChange(e.target.value, "recipientName")}
        />
        <TextField
          disabled={disabled}
          label={t("شماره_موبایل_گیرنده")}
          value={customerAddress.recipientPhoneNumber}
          error={formErrors.recipientPhoneNumber}
          className={classes["input"]}
          onChange={(e) => handleChange(e.target.value, "recipientPhoneNumber")}
        />
        {
          disabled &&
          <Button
            fullWidth
            color="danger"
            onClick={handleEditAddress}
          >
            {t("تغییر_آدرس")}
          </Button>
        }
      </div>
    </Fragment>
  )
}

export default React.memo(PoAddressDetails)